import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _asyncToGenerator from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import _regeneratorRuntime from "/workdir/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import some from 'lodash/some';
import cookies from 'js-cookie';
import inRegions from '@segment/in-regions';
import { loadAnalytics } from '@segment/tracking/scripts';
import getUrlPath from '@segment/utils/getUrlPath';
var DOMAIN = "segment.com";
var WRITE_KEY = process.env.SEGMENT_ANALYTICS_WRITEKEY || "";
var REQUIRED_DESTINATIONS = ["Segment.io", "Google Tag Manager"];
var inEU = inRegions(["EU"]);
var inCA = inRegions(["CA"]);
/**
 * Fetch destinations from app.segment.
 * @returns Promise of Destination's array
 */

var fetchDestinations = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var res, destinations, _iterator, _step, destination;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return fetch("https://cdn.segment.com/v1/projects/".concat(WRITE_KEY, "/integrations"));

          case 2:
            res = _context.sent;

            if (res.ok) {
              _context.next = 6;
              break;
            }

            console.log("Failed to fetch integrations from segment: HTTP ".concat(res.status, " ").concat(res.statusText));
            return _context.abrupt("return");

          case 6:
            _context.next = 8;
            return res.json();

          case 8:
            destinations = _context.sent;
            _iterator = _createForOfIteratorHelper(destinations);

            try {
              for (_iterator.s(); !(_step = _iterator.n()).done;) {
                destination = _step.value;
                destination.id = destination.creationName;
                delete destination.creationName;
              }
            } catch (err) {
              _iterator.e(err);
            } finally {
              _iterator.f();
            }

            return _context.abrupt("return", destinations);

          case 12:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function fetchDestinations() {
    return _ref.apply(this, arguments);
  };
}();
/**
 * Load Analytics JS if there is any change on preferences and don't load if
 * all preferences are not set to true.
 * @param {Object} destinationPreferences
 * @returns void
 */


var conditionallyLoadAnalytics = function conditionallyLoadAnalytics(destinationPreferences) {
  var _window$analytics;

  var isAnythingEnabled = false;

  if (some(destinationPreferences, function (pref) {
    return Boolean(pref);
  })) {
    isAnythingEnabled = true;
  } // Reload the page if the trackers have already been initialized so that
  // the user's new preferences can take effect.


  if ((_window$analytics = window.analytics) !== null && _window$analytics !== void 0 && _window$analytics.initialized) {
    window.location.reload();
  } // Don't load a.js at all if nothing has been enabled.


  if (isAnythingEnabled) {
    loadAnalytics(WRITE_KEY, {
      integrations: destinationPreferences,
      context: {
        page: {
          path: window.location.pathname,
          // Override page path to allow switching canonical urls without affecting tracking.
          referrerPath: getUrlPath(document.referrer)
        }
      }
    });
  }
};
/**
 * Save preferences to track-preferences cookie to send to analytics node events.
 * @param destinationPreferences
 * @param customPreferences
 */


var savePreferences = function savePreferences(destinationPreferences, customPreferences) {
  if (window.analytics) {
    window.analytics.identify({
      destinationTrackingPreferences: destinationPreferences,
      customTrackingPreferences: customPreferences
    });
  }

  var expires = 365; // A year

  var value = {
    version: 1,
    destinations: destinationPreferences,
    custom: customPreferences
  };
  cookies.set("tracking-preferences", JSON.stringify(value), {
    expires: expires
  });
};
/**
 * Add preferences to destinations depending on TRUSTARC'S consent decisions.
 * @param {Number[]} consentDecision e.g: [0,1,2,3] // enable all
 */


var setupPreferences = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(consentDecision) {
    var destinations, isImplied, requiredDestinations, destinationPreferences, customPreferences;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return fetchDestinations();

          case 2:
            destinations = _context2.sent;

            if (destinations) {
              _context2.next = 5;
              break;
            }

            return _context2.abrupt("return");

          case 5:
            isImplied = consentDecision.includes(0) && !inEU();
            requiredDestinations = REQUIRED_DESTINATIONS.reduce(function (acc, id) {
              acc[id] = consentDecision.some(function (decisionNumber) {
                return decisionNumber === 1 || isImplied;
              });
              return acc;
            }, {}); // Mapping destination preferences depending on the consent returned
            // from TrustArc API `getGDPRConsentDecision`.

            destinationPreferences = destinations.map(function (dest) {
              if (consentDecision.includes(3) && dest.category === "Advertising") return _defineProperty({}, dest.id, true); // Advertising

              if (consentDecision.includes(2)) return _defineProperty({}, dest.id, dest.category !== "Advertising"); // Functional

              if (consentDecision.includes(1)) return _defineProperty({}, dest.id, false); // Required

              if (consentDecision.includes(0)) {
                // Implied
                if (inEU()) {
                  return _defineProperty({}, dest.id, false);
                }

                if (inCA()) {
                  return _defineProperty({}, dest.id, dest.category !== "Advertising");
                }

                return _defineProperty({}, dest.id, true);
              }

              return _defineProperty({}, dest.id, false);
            }).reduce(function (allDestinations, destObject) {
              return _objectSpread(_objectSpread({}, destObject), allDestinations);
            }, _objectSpread({}, requiredDestinations) // [1] === overrides functional or adv as required.
            );
            customPreferences = {
              functional: consentDecision.includes(2) || isImplied,
              // Functional (trustarc)
              marketingAndAnalytics: consentDecision.includes(2) || isImplied,
              // Functional (trustarc)
              advertising: consentDecision.includes(3) || isImplied && !inCA() // Advertising (trustarc)

            };
            savePreferences(destinationPreferences, customPreferences);
            conditionallyLoadAnalytics(destinationPreferences);

          case 11:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function setupPreferences(_x) {
    return _ref2.apply(this, arguments);
  };
}();

export { DOMAIN, setupPreferences };